import { Container, Section } from 'chaoskit/src/components'
import { useTheme } from '@emotion/react'

import Link from '~components/Link'

const StaticFooter = () => {
  const theme = useTheme()

  return (
    <Section
      as="footer"
      css={{
        backgroundColor: '#fff',
      }}
    >
      <Container>
        <div
          css={{
            textAlign: 'center',
            color: '#818a91',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',

            '> *': {
              padding: '0 1em',
              fontWeight: '600',
            },

            [theme.mq.medium]: {
              flexDirection: 'row',
            },
          }}
        >
          <span>&copy; {new Date().getFullYear()} Gremlin Inc.</span>
          <span>All rights reserved.</span>
          <Link
            to="/privacy/"
            css={{
              color: '#818a91',
            }}
          >
            Privacy Policy
          </Link>
        </div>
      </Container>
    </Section>
  )
}
export default StaticFooter
